import { CarConfigurationServiceV1 } from '@volkswagen-onehub/car-configuration-feature-service';
import { FeatureServices } from '@feature-hub/core';

import { ModelsCarouselIntegratorOptions } from './create-options-from-query-params';

export function configureCommonFeatureServices(
  featureServices: FeatureServices,
  {
    carlineId,
    salesgroupId,
    trimName,
    showroomNodeId,
  }: ModelsCarouselIntegratorOptions,
): void {
  const carConfigurationService = featureServices[
    'car-configuration'
  ] as CarConfigurationServiceV1;

  if (showroomNodeId) {
    carConfigurationService.setDefaultContext(showroomNodeId);

    carConfigurationService.set({
      tenant: 'private',
      carlineId,
      salesGroupId: salesgroupId,
      trimName,
    });
  }
}
